import VendorOrdersHtml from './templates/vendor-orders.html';

export function VendorOrders () {
  return {
    controller: 'VendorOrdersCtrl',
    restrict: 'E',
    templateUrl: VendorOrdersHtml,
    scope: {
      vendor: '=',
      orders: '='
    }
  }
}